import { LoginContainer } from './LoginContainer';

export const NewLoginScreen = () => {
  return <LoginContainer />;
};
